import React, { Component } from 'react';
import { Field, reduxForm, reset } from 'redux-form';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import IconMenu from 'material-ui/IconMenu';
import { isValidNameWithSpace, renderTextField, renderAutoCompleteSingleSelect, isFloat } from './../../../components/reduxFields';

class GraphAnnotation extends Component {
  
  constructor(props) {
    super(props);        
    this.state = {            
        AnnotationLabel : [],
        xAxisDateOption : props.xAxisDateOption, 
      };  
  }

  dataAnnotationSubmit = (event) => {
    if(Number(event.XPosition) >= 0 && event.labelText)
    {
      let AnnotationLabel = this.state.AnnotationLabel;
      let label = {
                      point: {
                          x: Number(event.XPosition),
                          y: Number(event.YPosition),
                          xAxis: 0,
                          yAxis: 0
                      },
                      text: event.labelText,                        
                  };

      AnnotationLabel.push(label);  

      let AnnotationState = {
                        labels: this.state.AnnotationLabel,
                        labelOptions: {
                          x: 40,
                          y: -10
                        },
                        draggable: "",
                        shape: {
                                  type: 'rect',
                                  params: {
                                      x: 0,
                                      y: 0,
                                      width: 100,
                                      height: 100,    
                                      fill: 'none',                        
                                      stroke: '#09a7dc',
                                      strokeWidth:1
                                  }                      
                              }
                      };  
      this.props.dispatch(reset('GraphAnnotationForm'));
      // console.log('AnnotationLabel..........',AnnotationLabel)
      this.props.setAnnotationState(AnnotationState);
    }
}

handleChange = (input, selectedRecord) => {
  input.onChange(selectedRecord.value);
}

  renderAnnotations() {   
      
      const { handleSubmit } = this.props;
        return (
            <div>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.dataAnnotationSubmit)}>
                            <div className='row'>  
                                {/* <div className="col-sm-12">
                                    <Field
                                        name="XPosition"
                                        type="text"
                                        maxLength="2"
                                        label="X Position"                                        
                                        normalize={isInteger}
                                        component={renderTextField}
                                    />
                                </div> */}
                                <div className="col-sm-12 mt-35">
                                  <Field name="XPosition"
                                    label="X Position"
                                    handleNewRequest={this.handleChange}
                                    options={this.state.xAxisDateOption}
                                    component={renderAutoCompleteSingleSelect}
                                  />
                                </div>
                                <div className="col-sm-12">
                                    <Field
                                        name="YPosition"
                                        type="text"
                                        maxLength="3"
                                        label="Y Position"
                                        normalize={isFloat}
                                        component={renderTextField}
                                    />
                                </div>         
                                <div className="col-sm-12">
                                    <Field
                                        name="labelText"
                                        type="text"
                                        maxLength="100"
                                        label="Label Text"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>                                
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 btn_rt claims_filter mt-20">
                                <RaisedButton type="Submit" primary={true}>Add</RaisedButton>
                                {/* <RaisedButton className="grey_btn ml_15"  onTouchTap={this.handleClose}>Close</RaisedButton> */}
                            </div>
                        </form>
                    </div>                    
                </div>
            </div>
        )
  }

  render() {
    
    return (
      <div className='row'>
        <div className="col-12 col-sm-12 col-md-12 btn_lft reset-btn claims_filter mt-20">
          <IconMenu className="bell-icon"
            iconButtonElement={             
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Add Annotation</RaisedButton>                        
            }
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}            
          >
            {this.renderAnnotations()}
            
          </IconMenu>
        </div>
      </div>
    );
  }
}
GraphAnnotation = reduxForm({
  form: 'GraphAnnotationForm',
  enableReinitialize: true,
})(GraphAnnotation);

// function mapStateToProps(state) {
//   return {
//     notifications: state.notifications,
//   };
// }

export default connect(null)(GraphAnnotation);



// WEBPACK FOOTER //
// ./src/modules/patients/containers/graphAnnotation.js